import React from 'react';
import { createPortal } from 'react-dom';

interface SpinnerOverlayProps {
  message?: string;
}

const overlayContent = (message: string) => (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 2147483647,
      width: '100%',
      height: '100%',
      minHeight: '100vh',
      minWidth: '100vw',
      background: 'rgba(20,32,56,0.75)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          width: 55,
          height: 55,
          border: '5px solid #fff',
          borderTop: '5px solid #C2A32B',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }}
      />
      <div
        style={{
          marginTop: 18,
          color: 'white',
          fontWeight: 500,
          letterSpacing: 1.5,
          fontSize: 16,
          textShadow: '0 2px 10px #1E3557',
        }}
      >
        {message}
      </div>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg);}
            100% { transform: rotate(360deg);}
          }
        `}
      </style>
    </div>
  </div>
);

export const SpinnerOverlay: React.FC<SpinnerOverlayProps> = ({ message = 'Logging in...' }) => {
  if (typeof document === 'undefined') return null;
  return createPortal(overlayContent(message), document.body);
};

export default SpinnerOverlay;
